require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/set-prototype-of.js
 ** module id = 446
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/